import { Form, Input } from 'antd';

import { InputInterface } from '../utils/forms/FormInterface';

import './style.scss';

export interface InputProps {
  formInput: InputInterface;
  index: number;
  form?: any;
}

const TextInput = (props: InputProps) => {
  const { formInput, index } = props;

  return (
    <Form.Item
      key={index}
      wrapperCol={{ span: 8, offset: 4 }}
      labelCol={{ span: 4 }}
      label={<div className={!formInput.required ? 'leftOffset' : ''}>{formInput.label}</div>}
      colon={formInput.required}
      labelAlign="left"
      name={formInput.name}
      rules={[
        {
          required: formInput.required,
          message: formInput.errorMsg,
        },
        ...((formInput.rules ? formInput.rules : []) as Array<any>),
      ]}
    >
      <Input disabled={formInput.readonly} />
    </Form.Item>
  );
};

export default TextInput;
